var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayLogoNetflix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 32,
    viewBox: "0 0 119 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6040_28513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3005 29.9374C14.5255 30.2502 12.7192 30.3439 10.8506 30.5938L5.15138 13.8439V31.3126C3.37631 31.5 1.75692 31.7501 0.0751953 32V0H4.80902L11.2866 18.1566V0H16.3005V29.9374ZM26.1106 11.7188C28.0415 11.7188 31.0001 11.6249 32.7751 11.6249V16.6249C30.5639 16.6249 27.9792 16.6249 26.1106 16.7187V24.1563C29.0381 23.9688 31.9656 23.7187 34.9239 23.6249V28.437L21.1276 29.5311V0H34.9239V5.00001H26.1106V11.7188ZM53.4538 5.00013H48.2842V28.0001C46.6025 28.0001 44.9208 28.0001 43.3016 28.0624V5.00013H38.1319V0H53.4541L53.4538 5.00013ZM61.5509 11.3751H68.3712V16.375H61.5509V27.7189H56.6611V0H70.5823V5.00001H61.5509V11.3751ZM78.6794 23.3437C81.5135 23.4061 84.3785 23.6252 87.1503 23.7812V28.7187C82.697 28.4374 78.2436 28.1564 73.6967 28.0624V0H78.6794V23.3437ZM91.3545 29.0625C92.9428 29.1564 94.6245 29.2502 96.2439 29.4375V0H91.3545V29.0625ZM118.075 0L111.754 15.2188L118.075 32C116.207 31.7501 114.338 31.4062 112.469 31.0938L108.888 21.844L105.245 30.3439C103.438 30.0312 101.694 29.9374 99.8881 29.6874L106.303 15.0312L100.511 0H105.867L109.137 8.40628L112.625 0H118.075Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6040_28513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayLogoNetflix);
export default __webpack_public_path__ + "static/media/gray-logo-netflix.a47db6eaf2de7327844f27eb230da39c.svg";
export { ForwardRef as ReactComponent };